import { render, staticRenderFns } from "./WidgetLauncher.vue?vue&type=template&id=34a28aa4"
import script from "./WidgetLauncher.vue?vue&type=script&lang=js"
export * from "./WidgetLauncher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports